module.exports = __webpack_public_path__ + "img/login-bg-v1-latest.914fdc73.jpg";